    import { ChevronDownIcon, ChevronUpIcon } from "@fluentui/react-icons-mdl2";

    type DisplayArrowProp = {
        expanded: boolean
    }
    
    const DisplayArrow: React.FC<DisplayArrowProp> = ({ expanded }) => {
        return expanded ? (
            <ChevronUpIcon className="tableArrow" />
        ) : ( 
            <ChevronDownIcon className="tableArrow" />
        );
    };

    export default DisplayArrow;